/* styles/widgets/sliders.js */ function _(require, module, exports) {
    require(164) /* ../root */;
    require(495) /* ./nouislider */;
    var _a = require(163) /* ../../core/dom */;
    _a.styles.append(".bk-root .bk-slider-title {\n  white-space: nowrap;\n}\n.bk-root .bk-slider-value {\n  font-weight: 600;\n}\n");
    exports.bk_slider_value = "bk-slider-value";
    exports.bk_slider_title = "bk-slider-title";
    exports.bk_input_group = "bk-input-group";
}
